import { RECAPTCHA_KEY } from "@gcloud-npm/utils.c2c";
import sendRetargeting from "@gcloud-npm/adabyron.misc.send-retargeting";
import FrontSonda from "@gcloud-npm/utils.monitoring.front-sonda";
import sendGaComponentEvent from '@gcloud-npm/utils.metrics.send-ga-component-event';
import  {
  TEXT_ALIGN,
  TEXT_COLOR,
  TEXT_DISPLAY,
  TEXT_FONT_WEIGHT,
  TEXT_KIND,
  TEXT_SIZE,
} from "@/bit/components/components.text";

export const recaptchaActions = {
  RETARGETING: "retargeting_collect",
};

export const WEB_SERVICES = {
  RETARGETING: "retargeting",
};

export const HANDLING_CODES = {
  NOTHING_TO_DO: 1,
  FATAL: -1,
};

export const ERROR_PAGES = {
  DEFAULT: "default",
  CHECKOUT: "checkout",
};

export const defaultKoMessage = {
  'cms-atom-text-1': {
      text:"Ha ocurrido un error.",
      size: TEXT_SIZE.T3,
      color: TEXT_COLOR.GREY9,
      fontType: TEXT_FONT_WEIGHT.REGULAR,
      align: TEXT_ALIGN.CENTER
    },
  'cms-atom-text-2': {
      text:"Algo ha ido mal y no hemos podido recoger tus datos. Por favor, vuelve a intentarlo.",
      size: TEXT_SIZE.T4,
      color: TEXT_COLOR.GREY9,
      fontType: TEXT_FONT_WEIGHT.REGULAR,
      align: TEXT_ALIGN.CENTER
    },
  "cms-atom-icon-1": {
    circleLayout: 0,
    color: "orange",
    height: "48",
    id: "alerta",
    kind: "m",
    width: "auto"
  }
}

export const webServiceErrorHandler = {
  [WEB_SERVICES.RETARGETING]: {
    service: WEB_SERVICES.RETARGETING,
    handlingCode: {
      default: HANDLING_CODES.NOTHING_TO_DO,
    },
    errorToPrint: ERROR_PAGES.DEFAULT,
  },
};

export const getClientsIds = (context) => {
  const { clientIDs } = { ...context };
  const { ga: client_id, sessionId: session_id } = { ...clientIDs };
  const ga = {};
  if (client_id) {
    ga.client_id = client_id;
  }
  // se incluye session_id solo si existe client_id y tiene formato correcto
  if (session_id && client_id) {
    const gaRegex = /^\d+\.\d+$/;
    if (gaRegex.test(client_id)) {
      ga.session_id = session_id;
    }
  }
  let gaIds = "";
  if (Object.keys(ga).length > 0) {
    gaIds = JSON.stringify(ga);
  }
  return gaIds;
};

export const getReCaptchaToken = ({ action = "default" }) => {
  return new Promise((resolve) => {
    if (typeof window === "undefined" || !window.grecaptcha) {
      return resolve(null);
    }

    const grecaptchaInstance = window.grecaptcha.enterprise || window.grecaptcha;

    grecaptchaInstance.ready(() => {
      grecaptchaInstance.execute(RECAPTCHA_KEY, { action }).then((token) => {
        resolve(token);
      }).catch(() => {
        resolve(null);
      });
    });
  });
};


export const reportJSError = (error, processName, filePath, context) => {
  try {
    if (error instanceof Error) {
      const sonda = new FrontSonda({
        processName,
        filePath,
        context,
      });
      sonda.errorMessage({ error });
    }
  } catch (e) {
    // Nothing to do
  }
};

export const normalizeErrorInfo = (error, service, contextApi) => {
  const errorInfo = { ...webServiceErrorHandler[service] };
  try {
    const { handlingCode } = { ...errorInfo };
    const { status: errorCode } = { ...error };
    errorInfo.handlingCode = handlingCode[errorCode] || handlingCode.default;
    return errorInfo;
  } catch (e) {
    reportJSError(e, "normalizeErrorInfo", "utils/saga-utils", contextApi);
    return { ...errorInfo, handlingCode: -1 };
  }
};

export const getIdPartyHash = () => {
  const secureInfo = localStorage.getItem('@secure.j.ts');
  if(secureInfo === null) {
    return null;
  }
  const info = JSON.parse(atob(secureInfo));
  return info.userIdPartyHash;
}

export const reconstructData = (obj, needIdPartyHash = false) => {
    const dataReconstructed = {};

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        dataReconstructed[key] = obj[key].value;
      }
    }
    if(needIdPartyHash === true || needIdPartyHash === 'true') {
      dataReconstructed['encryptedPartyId'] = getIdPartyHash();
    }

    return dataReconstructed;
  };

export const reconstructConsents = (obj) => {
  const consentData = {};

  for (const key in obj) {
    if (key.includes("consents")) {
      consentData[key] = obj[key].label
    }

    return consentData;
  }
}

export const sendToRetargeting = async (context, data, consentData, idForm) => {
  const { contextURL } = { ...context };
  const { phone, name, surname1, document, email, encryptedPartyId} = data;
  delete data.phone;
  delete data.name;
  delete data.surname1;
  delete data.document;
  delete data.email;
  delete data.encryptedPartyId;
  const consents = [];
  for (var key in data) {
    if (key.includes("consents")) {
      consents.push({text: consentData[key] ,acceptance: data[key]});
      delete data[key];
    }
  }
  const dataPayload = {
    campaign: {
      id: idForm,
    },
    products: [],
    context: {
      url: btoa(contextURL || window.location.href),
      ga: getClientsIds(context),
    },
    contactInfo: {
      consents,
      phone: phone,
      name: name,
      surname1: surname1,
      document: document,
      email: email,
      encryptedPartyId: encryptedPartyId,
    },
    additionalInfo: JSON.stringify(data)
  };
  const recaptchaToken = await getReCaptchaToken({
    action: "retargeting_collect",
  });

  return sendRetargeting({ data: { ...dataPayload, recaptchaToken }, context });
};

  export const sendTaggingInfo = (taggingInfo, eventType, eventName = null) => {
    const finalTaggingInfo = {
      ...taggingInfo,
      eventType,
    };
    try {
      const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
      const isFrontApp = typeof window !== 'undefined';
      const isMetricsDevEnable =
        isFrontApp && window.location.search.indexOf('metrics') > -1;
      if ((isFrontApp && currentEnv !== 'dev') || isMetricsDevEnable) {
        if (eventName) {
          sendGaComponentEvent(finalTaggingInfo, { eventType: eventName });
        } else {
          sendGaComponentEvent(finalTaggingInfo);
        }
      }
    } catch (err) {
      const sonda = new FrontSonda({
        processName: `-${process.env.NEXT_PUBLIC_PROJECT_ID}`,
        filePath: `input-${window.location.href}`,
      });
      sonda.errorMessage(err);
      throw err;
    }
  };

  export const getPurchaseTag = (product, step, price) => {
    return {
      funnel_flow_name: "cms-purchase",
      funnel_purchase_mode: "migra",
      funnel_payment_method: "not-set",
      product: product,
      product_id: "not-set",
      promotion_id: "not-set",
      funnel_step_name: step,
      funnel_purchase_type: "manual",
      transaction_id: "not-set",
      funnel_flow_detail: `${product}-manual`,
      price: price
    }
  }


  export const conversePeopleMapIntoString = (map) => {
    try {
        var res = '';
        map.forEach(element => {
            if(element.age && element.gender) {
                res += `${res.length != 0 ? ' | ': ''}${element.label} ${element.gender}/${element.age}`
            }
        })
        return res  
    } catch (e) {
        return ''
    }
    
  }
  export const createDataObjet = (data) => {
    const res = {};
    Object.keys(data).forEach(key => {
        res[key] = data[key].value;
    });
    return res;
  }

export const createDefaultValues = (pagination) => {
  const defaultValues = {};
  pagination.forEach((page, pageIndex) => {
      const pageNumber = pageIndex + 1;
      (page['cms-ml-question-list-1'] || []).forEach(question => {
        defaultValues[question.nameId] = {
          value: '',
          error: '',
          valid: !(question.requiredField === true || question.requiredField === 'true'),
          required: (question.requiredField === true || question.requiredField === 'true'),
          validation: question.validation,
          label: question.label,
          page: pageNumber
        };
      });
    });

  return defaultValues;
};

export const getSteps = (pagination) => {
  return pagination.map(page => ({
    label: page.namePage
  }));
}
